import type { ComponentProps } from "react";
import { createPortal } from "react-dom";

/**
 * The child a lazy `InHouseTooltip` hands MUI's Tooltip, which needs one to mount. It is never seen or reached: the
 * popup is anchored to the real element (`slotProps.popper.anchorEl`) and opened by that element's listeners, so this
 * is hidden and portalled to the body, where it can't touch the anchor's layout or the selectors its siblings match.
 */
export const TooltipAnchorProxy = (props: ComponentProps<"span">) => createPortal(<span {...props} hidden />, document.body);
